export default {
  title: 'HubRise',
  setup: {
    description: "Partagez vos données avec d'autres applications.",
  },
  form: {
    is_menus_sync_enabled: 'Synchroniser le menu',
    is_inventory_sync_enabled: "Synchroniser l'inventaire",
    is_opening_hours_sync_enabled: "Synchroniser les horaires d'ouverture",
    is_order_acceptance_mode_sync_enabled: 'Synchroniser le statut occupé / en pause',
    variant_ref: 'Variante de menu',
    variant_ref_default: 'Par défaut',
  },
  tabs: {
    settings: 'Paramètres',
    service_types: 'Types de service',
    payments: 'Paiements',
    charges: 'Frais',
    deals: 'Offres',
    discounts: 'Remises',
    customers: 'Clients',
  },
  customers: {
    description:
      "Supprimer les données d'un client du côté HubRise, par exemple après une demande de suppression. Cette action est irréversible.",
    customer: 'Client',
    placeholder: 'Rechercher par nom, e-mail ou téléphone…',
  },
  mapping: {
    description:
      'Associez chaque entité {{provider}} à sa valeur et son nom HubRise correspondants. Laissez une ligne vide pour utiliser les valeurs par défaut de {{provider}}.',
    entity: '{{provider}}',
    value: 'Valeur HubRise',
    name: 'Nom HubRise',
  },
  connecting: {
    title: 'Finalisation de la connexion HubRise…',
    description: 'Cela prend quelques secondes. Gardez cette page ouverte.',
    error_title: 'La connexion HubRise prend plus de temps que prévu',
    error_description:
      "HubRise a été autorisé, mais la connexion n'est pas encore confirmée. Vérifiez à nouveau dans un moment — si le problème persiste, recommencez la connexion.",
  },
  buttons: {
    connect: 'Se connecter à HubRise',
    check_again: 'Vérifier à nouveau',
    disconnect: 'Déconnecter',
    go_to_hubrise: 'Aller sur HubRise',
    pull_menus: 'Importer le menu',
    pull_inventory: "Importer l'inventaire",
    save: 'Enregistrer',
    delete_customer: 'Supprimer le client',
  },
  toasts: {
    connected: 'HubRise a été connecté',
    connect_cancelled: 'La connexion HubRise a été annulée',
    connect_error: 'Échec du démarrage de la connexion HubRise',
    connect_timeout: "La connexion HubRise n'a pas encore pu être confirmée",
    local_changes_replaced:
      'Les paramètres HubRise ont été mis à jour ailleurs — vos modifications non enregistrées ont été remplacées',
    disconnect_success: 'HubRise a été déconnecté',
    disconnect_error: 'Échec de la déconnexion de HubRise',
    pull_menus_success: 'La synchronisation du menu a démarré',
    pull_menus_error: "Échec de l'importation du menu",
    pull_inventory_success: "La synchronisation de l'inventaire a démarré",
    pull_inventory_error: "Échec de l'importation de l'inventaire",
    save_success: 'Les paramètres HubRise ont été enregistrés',
    save_error: "Échec de l'enregistrement des paramètres HubRise",
    load_customers_error: 'Échec du chargement des clients',
    delete_customer_success: 'La suppression des données du client a été demandée',
    delete_customer_error: 'Échec de la suppression des données du client',
  },
  delete_customer_confirm: {
    title: 'Supprimer ce client de HubRise ?',
    description: 'Les données du client seront supprimées du côté HubRise. Cette action est irréversible.',
    ok: 'Supprimer',
    cancel: 'Annuler',
  },
  disconnect_confirm: {
    title: 'Déconnecter HubRise ?',
    description: 'Cela arrêtera la synchronisation des menus, stocks et commandes avec HubRise.',
    ok: 'Déconnecter',
    cancel: 'Annuler',
  },
  connected: {
    title: 'Connecté à HubRise',
    description: 'Votre compte HubRise est correctement lié.',
    account: 'Compte',
    location: 'Emplacement',
    catalog: 'Catalogue',
    customer_list: 'Liste de clients',
  },
};
